import apiClient from './apiClient';
import { GET_RESOURCE_BOOKING_LIST_URL } from './apiUrl';

const getResourceBookingListApi = () => {
  return apiClient.get(GET_RESOURCE_BOOKING_LIST_URL);
};

export { getResourceBookingListApi };
